__webpack_require__.p = "https://static.parastorage.com/services/restaurant-menus-showcase-ooi/74fa4804c945d24683ae4191d23c4bc4b62d09bc9ca4d6597653d2a2/";